export default "__VITE_ASSET__G95XPuhs__"